// 紙吹雪（式神を引いたとき）：画面の左右下から🎉が弾けて、色とりどりの紙片がひらひら舞い落ちる。
// ゲームの帯（#stage。PC では縦長の帯）いっぱいに重ねた Canvas に描き、終わったら取り除く（タップは下に通す）。reduced（揺れを減らす設定）では少なめ・短め。
const COLORS = ['#ff4d6d', '#ffd23f', '#3ec1ff', '#5ee07a', '#ff8de1', '#ffffff', '#ff9a3c', '#b18cff'];

interface Piece {
  x: number;
  y: number;
  vx: number;
  vy: number;
  w: number;
  h: number;
  rot: number;
  vr: number;
  /** 裏返り（紙が回って細く見える）の位相 */
  flip: number;
  vf: number;
  color: string;
  ribbon: boolean;
}

/** top：全画面の演出（おみくじ・錬成, z-index 900）より手前に出す */
export function confetti(opts: { reduced?: boolean; speed?: number; top?: boolean } = {}) {
  const speed = Math.max(0.5, opts.speed ?? 1);
  const cv = document.createElement('canvas');
  cv.className = 'confetti';
  cv.setAttribute('aria-hidden', 'true');
  cv.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:' + (opts.top ? 950 : 60);
  const host = (opts.top ? null : document.getElementById('stage')) ?? document.body;
  host.appendChild(cv);
  const dpr = Math.min(window.devicePixelRatio || 1, 2);
  const W = host.clientWidth || window.innerWidth;
  const H = host.clientHeight || window.innerHeight;
  cv.width = Math.round(W * dpr);
  cv.height = Math.round(H * dpr);
  const ctx = cv.getContext('2d')!;
  ctx.scale(dpr, dpr);

  // 紙吹雪は左右下の2か所から斜め上・内側へ（クラッカーの絵は出さない）
  const poppers = [
    { x: W * 0.07, y: H * 0.86, dir: 1 },
    { x: W * 0.93, y: H * 0.86, dir: -1 },
  ];

  const n = opts.reduced ? 50 : Math.round(Math.min(180, 90 + W * 0.08));
  const pieces: Piece[] = [];
  const base = Math.min(W, H);
  for (let i = 0; i < n; i++) {
    const p = poppers[i % 2];
    // 斜め上・内側へ（左は右上へ、右は左上へ）
    const ang = -Math.PI / 2 + p.dir * (0.25 + Math.random() * 0.55);
    const v = base * (2.2 + Math.random() * 1.0);
    pieces.push({
      x: p.x,
      y: p.y,
      // 横は抑えめ（画面の外へ飛び出さず、左右から中ほどまで届く）
      vx: Math.cos(ang) * v * 0.45,
      vy: Math.sin(ang) * v,
      w: 6 + Math.random() * 6,
      h: 9 + Math.random() * 8,
      rot: Math.random() * Math.PI * 2,
      vr: (Math.random() - 0.5) * 12,
      flip: Math.random() * Math.PI * 2,
      vf: 6 + Math.random() * 8,
      color: COLORS[i % COLORS.length],
      ribbon: Math.random() < 0.18,
    });
  }
  const life = (opts.reduced ? 2200 : 3600) / speed;
  const start = performance.now();
  let last = start;
  const step = (now: number) => {
    const dt = Math.min(0.05, (now - last) / 1000) * speed;
    last = now;
    const t = (now - start) / life;
    ctx.clearRect(0, 0, W, H);
    for (const p of pieces) {
      // 空気の抵抗（紙なのですぐ減速して、ゆっくり落ちる）と重力、左右のゆらぎ
      p.vx *= Math.pow(0.4, dt);
      p.vy = p.vy * Math.pow(0.4, dt) + base * 0.9 * dt;
      p.vy = Math.min(p.vy, base * 0.32);
      p.x += (p.vx + Math.sin(p.flip) * base * 0.06) * dt;
      p.y += p.vy * dt;
      p.rot += p.vr * dt;
      p.flip += p.vf * dt;
      ctx.save();
      ctx.globalAlpha = t > 0.75 ? Math.max(0, (1 - t) / 0.25) : 1;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.scale(1, Math.cos(p.flip));
      ctx.fillStyle = p.color;
      if (p.ribbon) {
        // 細長いテープ（くるっと曲がる）
        ctx.beginPath();
        ctx.moveTo(-p.w * 0.3, -p.h * 1.4);
        ctx.quadraticCurveTo(p.w * 1.2, 0, -p.w * 0.3, p.h * 1.4);
        ctx.lineWidth = 3;
        ctx.strokeStyle = p.color;
        ctx.stroke();
      } else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    }
    if (t < 1) requestAnimationFrame(step);
    else cv.remove();
  };
  requestAnimationFrame(step);
}
